import React from 'react';
import useReactRouter from 'use-react-router';
import { Router, Route, Switch, Redirect } from 'react-router';
import { NavLink } from 'react-router-dom';
import { DsLogo } from '@tokenyico/design-system/dist/reactJS';

import {
  PageSidebar,
  PageSidebarHeader,
  PageSidebarMenu,
  PageContainer,
  PageView,
  EthAvatar,
} from '@tokenyico/tokeny-ui';
import { getInvestorName } from 'app/helpers/investor';
import { connect } from 'redux-zero/react';

import ProfileBasicInfoView from './ProfileBasicInfoView';
import ProfileOnchainidView from './ProfileOnchainidView';
import ProfileBasicInfoEdit from './ProfileBasicInfoEdit';

const tabs = [
  // {
  //   label: 'Profile',
  //   itemPath: '/profile/status',
  // },
  {
    label: 'Profile',
    itemPath: '/profile/basic-info',
  },
  {
    label: <DsLogo name="onchainid" style={{ width: '6rem', height: '1.5rem' }} />,
    itemPath: '/profile/onchainid',
  },
];

const edit = [
  {
    label: 'Basic information',
    itemPath: '/profile/basic-info/edit',
  },
];

const ProfileView = ({ user }) => {
  const { history } = useReactRouter();

  return (
    <PageContainer className="profile-view">
      <PageContainer className="card shadow-2">
        <PageSidebar className="col-xs-12">
          <PageSidebarHeader>
            <div className="_m:top(4) _m:bottom(2)">
              <EthAvatar size={64} address={user.identityAddress || ''} />
            </div>
            <div className="_text(500) _m:bottom(1)">{getInvestorName(user)}</div>
          </PageSidebarHeader>
          <PageSidebarMenu>
            <ul>
              {tabs.map((tab, key) => (
                <li key={key}>
                  <NavLink activeClassName="active" to={tab.itemPath}>
                    {tab.label}
                  </NavLink>
                </li>
              ))}
            </ul>
          </PageSidebarMenu>
        </PageSidebar>
        <PageView>
          <Router history={history}>
            <Switch>
              <Route path={edit[0].itemPath} component={ProfileBasicInfoEdit} />
              <Route path={tabs[0].itemPath} component={ProfileBasicInfoView} />
              <Route path={tabs[1].itemPath} component={ProfileOnchainidView} />

              <Redirect from="/profile" to="/profile/basic-info" />
            </Switch>
          </Router>
        </PageView>
      </PageContainer>
    </PageContainer>
  );
};

const mapToProps = ({ holder: { user } }) => ({
  user,
});

export default connect(mapToProps)(ProfileView);
